import { computed } from 'vue';
import { useGetPageSection } from './useGetPageSection';

export interface IsSectionVisibleParams {
  registryId: string;
  sectionKey: string;
  blockKey?: string;
}

/**
 * Composable to check if a section should be visible
 * Returns false if section doesn't exist, is not loaded, or has show: false
 * @param params - Object containing registryId, sectionKey, and optional blockKey
 * @returns Computed boolean indicating if section is visible
 */
export const useIsSectionVisible = ({ registryId, sectionKey, blockKey }: IsSectionVisibleParams) => {
  const section = useGetPageSection({ registryId, sectionKey, blockKey });

  return computed(() => {
    if (!section.value) {
      return false;
    }

    // If show is explicitly false, section is not visible
    // If show is undefined or true, section is visible
    return section.value.show !== false;
  });
};
